module.exports = __webpack_public_path__ + "static/media/disclosure.dd9e44f4.svg";